import React from 'react'
import * as d3 from "../d3.modified.js"
import {PreviewNodebook} from '../PreviewNodebook'
import constants from '../../ndbk-constants'

export default class RefNode extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove
        }
    }

    componentDidMount() {
        this.postModifiers()

        var node = this.props.nodeItem

        this.position = undefined
        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()
            })
            .on('drag', ()=>{

                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                    this.props.dragHandler(d3.event.dx, d3.event.dy)
                }
            })
            .on('end', ()=>{
                let newPosition = {x:d3.event.x, y:d3.event.y}
                if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                    this.props.dragEndHandler(node)
                }
            })
        )

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })
    }

    postModifiers = () => {
        var node = this.props.nodeItem

        // var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        // if (node.settings.render['title']===false) {
        //     return
        // }

        // var hasTitle = (node.properties.title!=='')
        // if (hasTitle) {
        //     var bb = node.refs.title.getBBox()
        //     node.width = bb.width
        //     _(node.refs.background, 'width', node.width+10)
        //     _(node.refs.background, 'x', -node.width/2-5)
        // } else {
        //     node.width = 0
        //     _(node.refs.background, 'width', node.width)
        // }

        // // this.props.enqueueStyleChange({
        // //     elem: node.refs.background,
        // //     prop: 'fill',
        // //     val: node.properties.color
        // // })
        // this.props.enqueueStyleChange({
        //     elem: node.refs.icon,
        //     prop: 'fill',
        //     val: node.properties.color
        // })
    }

    componentDidUpdate() {
        this.postModifiers()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.icon,
        //     class: 'active',
        //     val: true,
        // })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.icon,
        //     class: 'active',
        //     val: false,
        // })
    }

    render() {
        var node = this.props.nodeItem

        return (
            <g
                className="node-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
            >
                {
                    <foreignObject x="0" y="0" width="300" height="200" ref={c=>node.refs.preview=d3.select(c)}>
                        <div xmlns="http://www.w3.org/1999/xhtml">
                            KITA
                        </div>

                        <PreviewNodebook nowrap xmlns nodatasohereisid={node.properties.ref.nodebook_id}/>
                    </foreignObject>
                }
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/RefNode.js